import { useBookmarkStore } from '@/state/bookmarkStore';
import type { Tool } from './types';

export const bookmarkList: Tool<Record<string, never>> = {
  name: 'bookmark_list',
  description: 'List saved bookmarks (id, name, layer count, created_at).',
  input_schema: { type: 'object', properties: {}, additionalProperties: false },
  execute: () => {
    return useBookmarkStore.getState().bookmarks.map((b) => ({
      id: b.id,
      name: b.name,
      visible_layer_ids: b.visible_layer_ids,
      created_at: b.created_at,
    }));
  },
};
